const lib = {
  translationTraining: 'https://forms.gle/frxmywjQLxQtiXoT7',
  volunteerApplication: 'https://forms.gle/biY5hp181iARUwok7',
  partnershipContact: 'https://forms.gle/7Q6njUmmTPSRmdfz7'
}

export type GoogleFormLinkKey = keyof typeof lib

function googleFormService(key: GoogleFormLinkKey) {
  return lib[key]
}

export default googleFormService
